import React from "react";
import { AlertTriangle, CalendarClock, CheckCircle2 } from "lucide-react";

// HU/TÜV-Fälligkeit: exaktes Datum (tuev_until/hu_date, auch YYYY-MM) oder
// Schätzung aus der Erstzulassung (erste HU nach 24 Monaten, dann alle 24).
export function computeHuDue(v) {
    if (!v) return null;
    const parse = (s) => {
        if (!s) return null;
        const str = String(s).slice(0, 10);
        if (/^\d{4}-\d{2}$/.test(str)) {
            const [y, m] = str.split("-").map(Number);
            return new Date(y, m, 0); // HU gilt bis Monatsende
        }
        const d = new Date(str);
        return isNaN(d.getTime()) ? null : d;
    };
    let due = parse(v.tuev_until || v.hu_date);
    let estimated = false;
    if (!due) {
        const fr = parse(v.first_registration || v.first_registration_date);
        const cat = String(v.category || "").toLowerCase();
        const isMotorized = !cat || cat.includes("motor") || cat.includes("roller") || cat.includes("krad") || cat.includes("zweirad");
        if (fr && isMotorized) {
            estimated = true;
            due = new Date(fr);
            due.setMonth(due.getMonth() + 24);
            const today = new Date();
            while (due < today) due.setMonth(due.getMonth() + 24);
        }
    }
    if (!due) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const diffDays = Math.round((due - today) / 86400000);
    const monthsLeft = Math.floor(diffDays / 30.44);
    const fmt = `${String(due.getMonth() + 1).padStart(2, "0")}/${due.getFullYear()}`;
    const est = estimated ? " — geschätzt aus Erstzulassung (alle 24 Monate), bitte prüfen" : "";
    if (diffDays < 0) return { state: "overdue", estimated, due: fmt, monthsLeft, label: `ABGELAUFEN seit ${fmt}${est}` };
    if (diffDays <= 90) return { state: "soon", estimated, due: fmt, monthsLeft, label: `fällig ${fmt} — nur noch ${diffDays} Tage${est}` };
    return { state: "ok", estimated, due: fmt, monthsLeft, label: `gültig bis ${fmt} — noch ca. ${monthsLeft} Monate${est}` };
}

const STYLES = {
    overdue: "bg-red-50 border-red-500 text-red-900",
    soon: "bg-amber-50 border-amber-500 text-amber-900",
    ok: "bg-emerald-50 border-emerald-500 text-emerald-900",
};
const ICONS = {
    overdue: <AlertTriangle className="w-4 h-4 shrink-0 text-red-600" />,
    soon: <CalendarClock className="w-4 h-4 shrink-0 text-amber-600" />,
    ok: <CheckCircle2 className="w-4 h-4 shrink-0 text-emerald-600" />,
};

export function HuStatusBanner({ vehicle, testId = "hu-status-banner" }) {
    const hu = computeHuDue(vehicle);
    if (!hu) return null;
    return (
        <div className={`border-l-4 rounded-sm px-3 py-1.5 text-xs font-bold flex items-center gap-2 ${STYLES[hu.state]}`} data-testid={testId}>
            {ICONS[hu.state]}
            <span>TÜV/HU {hu.label}</span>
        </div>
    );
}
